import styled from 'styled-components';

export const ByocProgressBarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 70%;
  margin: 29px 0;
  padding: 0 100px;
  position: relative;
  @media (max-width: 970px) {
    width: 100%;
    padding: 0 20px;
  }
`;

export const ByocProgressStep = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 2;
  min-width: 100px;
`;

export const ByocProgressStepCircle = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 16px;
  position: relative;
  z-index: 3;
  transition: all 0.3s ease;

  ${({$isCompleted}) =>
    $isCompleted &&
    `
    background-color: #ff2d38;
    color: white;
    border: 2px solid #ff2d38;
  `}

  ${({$isActive}) =>
    $isActive &&
    `
    background-color: #ff2d38;
    color: white;
    border: 2px solid #ff2d38;
  `}

  ${({$isPending}) =>
    $isPending &&
    `
    background-color: #ffffff;
    color: #929cb9;
    border: 2px solid #d5d8de;
  `}

  svg {
    display: block;
  }

  span {
    display: block;
    line-height: 1;
  }
`;

export const ByocProgressStepLabel = styled.div`
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 3px;
  font-size: ${({$isActive}) => ($isActive ? '16px' : '14px')};
  font-weight: ${({$isActive}) => ($isActive ? '700' : '400')};
  color: ${({$isCompleted, $isActive, $isPending}) => {
    if ($isCompleted || $isActive) return '#2f3d48';
    if ($isPending) return '#929cb9';
    return '#2f3d48';
  }};
  text-align: center;
  white-space: nowrap;
  transition: all 0.3s ease;
  pointer-events: none;
`;

export const ByocProgressLine = styled.div`
  flex: 1;
  max-width: 200px;
  height: 3px;
  margin: 0 10px;
  position: relative;
  z-index: 1;
  transition: all 0.3s ease;
  background-color: ${({$isCompleted}) =>
    $isCompleted ? '#ff2d38' : '#d5d8de'};
`;
